const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  publicToken: state => state.user.publicToken,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  username: state => state.user.username,
  introduction: state => state.user.introduction,
  clientId: state => state.user.clientId,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  addRouters: state => state.permission.addRoutes,
  errorLogs: state => state.errorLog.logs
}
export default getters
